/**
 * Up to two letters for a name, for an avatar that stands beside the name.
 *
 * "Abhishek Verma" is "AV", "Crux" is "C". Always decorative: the full name is
 * printed next to it, so the letters are hidden from a screen reader.
 */
export function initialsOf(name: string): string {
  const words = name
    .trim()
    .split(/\s+/u)
    .filter((word) => word !== "");
  const letters = words.slice(0, 2).map((word) => word.charAt(0).toUpperCase());
  return letters.join("");
}
